import React from "react";
import {
  TextInput,
  LongTextInput,
  ReferenceArrayInput,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  NumberInput,
  SelectArrayInput,
} from "admin-on-rest";
import RichTextInput from "aor-rich-text-input";
import { Field } from "redux-form";
import SelectProductArrayInput from "../SelectProductArrayInput";
import { SelectArrayChipInput } from "../../components/selectchip";
import TabbedForm from "./TabbedForm";
import FormMain from "./FormMain";

import { renderDateField, renderTimeField } from "../../orders/OrderFormField";
import { toolbar, validateProductEdit } from "../defaultValues";
import { choichesProductType } from "../Create";

const creaditMode = [
  { id: "credit_card", name: "Credit Card" },
  { id: "bank_transfer", name: "Bank Transfer" },
];

const choichesPlanType = [
  { id: "fpp", name: "Indosat MSP Freedom Postpaid Plus Plan" },
  { id: "sp", name: "Indosat MSP Super Plan" },
];

export const ProductEditTabbedForm = ({ permissions, ...props }) => {
  return (
    <TabbedForm {...props} validate={validateProductEdit}>
      <FormMain label="main">
        <BooleanInput
          label="resources.products.fieldList.active"
          source="active"
        />
        {permissions === "Admin" && (
          <ReferenceInput
            label="resources.products.fieldList.account"
            source="account_id"
            reference="accounts"
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
        )}
        <LongTextInput
          label="resources.products.fieldList.name"
          source="name"
        />
        <SelectInput
          label="resources.products.fieldList.productType.title"
          source="product_type"
          choices={choichesProductType}
          defaultValue={"Product"}
        />
        <TextInput label="resources.products.fieldList.slug" source="slug" />
        <SelectArrayChipInput
          label="resources.products.fieldList.tags"
          source="tags"
        />
        <ReferenceArrayInput
          label={"resources.products.fieldList.collections"}
          source="collections"
          reference="collections"
          allowEmpty
          perPage={1000}
        >
          <SelectProductArrayInput optionText="name" />
        </ReferenceArrayInput>
        <ReferenceInput
          label="resources.products.fieldList.category"
          source="category_id"
          reference="categories"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>

        <LongTextInput
          label="resources.products.fieldList.brand"
          source="brand"
        />

        <NumberInput
          label="resources.products.fieldList.price"
          source="price"
          parse={(v) => v * 1}
        />
        <NumberInput
          label="resources.products.fieldList.discount"
          source="discount"
          hintText="0.1 for 10% or 500000"
        />

        <NumberInput
          label="resources.products.fieldList.margin"
          source="margin"
          parse={(v) => v * 1}
        />
        <NumberInput
          label="resources.products.fieldList.partner_margin"
          source="partner_margin"
          parse={(v) => v * 1}
        />
        <NumberInput
          elStyle={{ width: 100 }}
          label="resources.products.fieldList.sortOrder"
          source="sort_order"
          parse={(v) => v * 1}
        />
        <RichTextInput
          source="description"
          name="description"
          toolbar={toolbar}
        />
        <TextInput
          label="resources.products.fieldList.properties.screenSize"
          source="properties.Screen size"
        />
        <TextInput
          label="resources.products.fieldList.properties.cpu"
          source="properties.CPU"
        />
        <TextInput
          label="resources.products.fieldList.properties.resolution"
          source="properties.Resolution"
        />
        <SelectArrayInput
          label="resources.products.fieldList.payment.enabled_payments"
          source="payment.enabled_payments"
          choices={creaditMode}
          options={{ fullWidth: true }}
        />
        <SelectArrayChipInput
          label="resources.products.fieldList.payment.bin"
          source="payment.credit_card.bin"
          options={{ fullWidth: true }}
        />
        <BooleanInput
          label="resources.products.fieldList.payment.installment"
          source="payment.installment"
        />
        <NumberInput
          label="resources.products.fieldList.shipping.weight"
          source="shipping.weight"
        />
        <BooleanInput
          label="resources.products.fieldList.shipping.free_shipping"
          source="shipping.free_shipping"
        />
        <NumberInput
          elStyle={{ width: 100 }}
          label="resources.products.fieldList.shipping.subsidy"
          source="shipping.subsidy"
          parse={(v) => v * 1}
        />
        <Field
          label="Event Date"
          name="event.date"
          source="event.date"
          component={renderDateField}
        />
        <Field
          label="Event Time"
          name="event.date"
          source="event.date"
          component={renderTimeField}
        />
        <LongTextInput
          label="resources.products.fieldList.term"
          source="event.term"
        />

        <ReferenceInput
          label={"resources.products.fieldList.payment.paymentmode"}
          source="payment_mode_id"
          reference="paymentmode"
        >
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>
        <SelectInput
          label="resources.products.fieldList.productType.titlePlanType"
          source="plan_type"
          choices={choichesPlanType}
          options={{ fullWidth: true }}
        />
      </FormMain>
    </TabbedForm>
  );
};



// WEBPACK FOOTER //
// ./src/products/form/ProductEditTabbedForm.js